import { render, staticRenderFns } from "./ReportIssue.vue?vue&type=template&id=4ed9fbd2"
import script from "./ReportIssue.vue?vue&type=script&lang=ts"
export * from "./ReportIssue.vue?vue&type=script&lang=ts"
import style0 from "./ReportIssue.vue?vue&type=style&index=0&id=4ed9fbd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports